import { useEffect, useState } from "react";
import styled from "styled-components";
import assets from "../../utils/ImagesPath";
import LS_SERVICE from "../../utils/localStorage";
import {
  LOGIN,
  VERIFY_OTP,
  SENT_OTP,
  IMAGE_BASE_URL,
} from "../../constants/api";
import { Divider } from "antd-mobile";
import { Form, Input, Spin, Button } from "antd";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { postAPI, displayMessage } from "../../utils/common";
import {
  CREATOR_LINK,
  CREATOR_NAME,
  PROJECT_NAME,
} from "../../constants/constent";
import { Link } from "react-router-dom";

const Login = () => {
  const [companyName] = useState(PROJECT_NAME);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  const [formType, setFormType] = useState("login"); // 'login' | 'forgot' | 'otp'
  const [loading, setLoading] = useState(false);
  const [mobile, setMobile] = useState(null);

  const logo = assets.logo;
  const images = assets.backgrounds;

  useEffect(() => {
    const interval = setInterval(changeBackgroundImage, 10000);
    return () => clearInterval(interval);
  }, [currentIndex, images.length]);

  const changeBackgroundImage = () => {
    setVisible(false);
    setTimeout(() => {
      setCurrentIndex((currentIndex + 1) % images.length);
      setVisible(true);
    }, 1000); // 1 second fade-out
  };

  const handleForgotClick = () => {
    setFormType("forgot");
  };

  const handleOpenLink = () => {
    window.open(CREATOR_LINK, "_blank", "noopener,noreferrer");
  };
  const handleLoginFinish = (values) => {
    setLoading(true);
    const data = new FormData();
    data.append("email", values.username);
    data.append("password", values.password);
    data.append("user_type", "Admin");
    const successFn = function (data) {
      if (data["status"] === true) {
        if (data["user"]["user_type"] === "customer") {
          setLoading(false);
          displayMessage(
            ERROR_MSG_TYPE,
            "Customer accounts are restricted from accessing this portal."
          );
        } else {
          LS_SERVICE.set("id", data["user"]["id"]);
          LS_SERVICE.set("name", data["user"]["name"]);
          LS_SERVICE.set("user_type", data["user"]["user_type"]);
          LS_SERVICE.set("phone", data["user"]["phone"]);
          LS_SERVICE.set("email", data["user"]["email"]);
          LS_SERVICE.set("token", data["token"]);
          LS_SERVICE.set("isCustomer", false);
          setLoading(false);
          displayMessage(
            SUCCESS_MESSAGE,
            data["message"] ?? "Login successful! Redirecting..."
          );
          window.location.reload();
        }
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data["message"] ?? "Fail to Login");
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Fail to Login");
    };
    postAPI(LOGIN, data, successFn, errorFn);
  };

  const handleForgotFinish = (values) => {
    const { mobile } = values;
    if (mobile.length === 10) {
      setLoading(true);
      const data = new FormData();
      data.append("mobileNo", mobile);
      const successFn = function (data) {
        if (data["status"] === true) {
          setMobile(mobile);
          setFormType("otp");
          setLoading(false);
          displayMessage(SUCCESS_MESSAGE, data["message"]);
        } else {
          setLoading(false);
          displayMessage(ERROR_MSG_TYPE, data["message"]);
        }
      };
      const errorFn = function () {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Failed to send OTP.");
      };
      postAPI(SENT_OTP, data, successFn, errorFn);
    } else {
      displayMessage(ERROR_MSG_TYPE, "Enter valid 10-digit mobile number.");
    }
  };

  const handleOtpFinish = (values) => {
    const { otp } = values;
    if (otp.length === 4) {
      setLoading(true);
      const data = new FormData();
      data.append("mobileNo", mobile);
      data.append("otp", otp);
      const successFn = function (data) {
        if (data["status"] === true) {
          setLoading(false);
          setMobile(null);
          setFormType("login");
          displayMessage(SUCCESS_MESSAGE, data["message"]);
        } else {
          setLoading(false);
          displayMessage(ERROR_MSG_TYPE, data["message"]);
        }
      };
      const errorFn = function () {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "OTP verification failed.");
      };
      postAPI(VERIFY_OTP, data, successFn, errorFn);
    } else {
      displayMessage(ERROR_MSG_TYPE, "Enter valid 4-digit OTP.");
    }
  };

  return (
    <StyledWrapper>
      <div
        className={`background-layer ${visible ? "visible" : ""}`}
        style={{ backgroundImage: `url(${images[currentIndex]})` }}
      />
      <div className="form-container">
        {formType === "login" ? (
          <>
            <div className="login-logo">
              <img
                src={
                  LS_SERVICE.get("setting")
                    ? `${IMAGE_BASE_URL}${LS_SERVICE.get("setting")["logo"]}`
                    : logo
                }
                alt="Logo"
              />
            </div>
            <Divider />
          </>
        ) : null}
        <p className="title">
          {formType === "login" && "Welcome Back"}
          {formType === "forgot" && "Reset Your Password"}
          {formType === "otp" && "Verify Your Identity"}
        </p>
        <p className="subtitle">
          {formType === "login" && "Sign in to access your account"}
          {formType === "forgot" &&
            "Enter your registered mobile number to receive a verification code"}
          {formType === "otp" &&
            "Enter the 4-digit OTP sent to your registered email"}
        </p>
        <Spin spinning={loading}>
          {formType === "login" && (
            <Form
              layout="vertical"
              className="form"
              onFinish={handleLoginFinish}
            >
              <Form.Item
                name="username"
                rules={[
                  {
                    required: true,
                    message: "Please enter your username/phone/email!",
                  },
                ]}
              >
                <Input
                  className="input"
                  placeholder="Enter Username/Phone/Email"
                />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[
                  { required: true, message: "Please enter your password" },
                ]}
              >
                <Input.Password
                  className="input"
                  placeholder="Enter Password"
                />
              </Form.Item>

              <p className="page-link">
                <span className="page-link-label" onClick={handleForgotClick}>
                  Forgot Password?
                </span>
              </p>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="form-btn"
                  block
                  loading={loading}
                >
                  Log in
                </Button>
              </Form.Item>
            </Form>
          )}

          {formType === "forgot" && (
            <Form
              layout="vertical"
              className="form"
              onFinish={handleForgotFinish}
            >
              <Form.Item
                name="mobile"
                rules={[
                  {
                    required: true,
                    message: "Please enter your mobile number",
                  },
                  {
                    pattern: /^[0-9]{10}$/,
                    message: "Mobile number must be 10 digits",
                  },
                ]}
              >
                <Input className="input" placeholder="Enter Mobile Number" />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="form-btn"
                  block
                  loading={loading}
                >
                  Send OTP
                </Button>
              </Form.Item>
              <p className="page-link" style={{ textAlign: "center" }}>
                <span
                  className="page-link-label"
                  onClick={() => setFormType("login")}
                >
                  Back to Login
                </span>
              </p>
            </Form>
          )}

          {formType === "otp" && (
            <Form layout="vertical" className="form" onFinish={handleOtpFinish}>
              <Form.Item name="mobile">
                <Input
                  disabled
                  defaultValue={mobile}
                  className="input"
                  placeholder="Enter Mobile Number"
                />
              </Form.Item>
              <Form.Item
                name="otp"
                rules={[
                  { required: true, message: "Please enter the OTP" },
                  {
                    pattern: /^[0-9]{4}$/,
                    message: "OTP must be 4 digits",
                  },
                ]}
              >
                <Input
                  className="input"
                  placeholder="Enter 4-digit OTP"
                  maxLength={4}
                />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="form-btn"
                  block
                  loading={loading}
                >
                  Verify OTP
                </Button>
              </Form.Item>
              <p className="page-link" style={{ textAlign: "center" }}>
                <span
                  className="page-link-label"
                  onClick={() => setFormType("login")}
                >
                  Back to Login
                </span>
              </p>
            </Form>
          )}
        </Spin>
        <Divider />
        <p className="page-link" style={{ textAlign: "center" }}>
          {LS_SERVICE.get("setting")
            ? LS_SERVICE.get("setting")["company_name"] + " "
            : companyName + " "}
          ©{new Date().getFullYear()} Created by{" "}
          <Link onClick={handleOpenLink} to="#">
            {CREATOR_NAME}
          </Link>
        </p>
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  position: relative;
  height: 100vh;
  width: 100vw;
  overflow: hidden;

  display: flex;
  justify-content: center;
  align-items: center;

  .background-layer {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    transition: opacity 1s ease-in-out;
    z-index: 0;
    opacity: 0;
  }

  .background-layer.visible {
    opacity: 1;
  }

  .form-container {
    position: relative;
    z-index: 1;
    width: 500px;
    height: auto;
    background-color: #fff;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 20px 30px;
  }
  .login-logo {
    width: 100%;
    height: 90px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .login-logo img {
    width: 50%;
    height: 100%;
    object-fit: contain;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .title {
    text-align: start;
    margin: 5px 0 10px 0;
    font-size: 28px;
    font-weight: 800;
    color: black;
  }
  .subtitle {
    text-align: start;
    font-size: 14px;
    color: #666;
    margin-bottom: 20px;
  }
  .form {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-bottom: 15px;
  }

  .input {
    border-radius: 20px;
    border: 1px solid #c0c0c0;
    outline: 0 !important;
    box-sizing: border-box;
    padding: 12px 15px;
  }

  .page-link {
    text-decoration: none;
    margin: 0;
    text-align: end;
    color: #747474;
    text-decoration-color: #747474;
  }

  .page-link-label {
    cursor: pointer;

    font-size: 14px;
    font-weight: 700;
  }

  .page-link-label:hover {
    color: #000;
  }

  .form-btn {
    padding: 22px 15px;
    border-radius: 20px;
    border: 0 !important;
    outline: 0 !important;
    background: var(--primary-color);
    color: white;
    cursor: pointer;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    margin-top: 15px;
  }

  .form-btn:active {
    box-shadow: none;
  }

  @media (max-width: 600px) {
    .form-container {
      margin-right: 20px;
      margin-left: 20px;
    }
  }
`;

export default Login;
